
import Vue from "vue";
import {Department, getDepartmentName} from "@/utils/department";
import { SettingsService } from "@/services/settings-service";

export default Vue.extend({
	data() {
		return {
			joinedDepartments: [] as Department[],
			ready: false
		};
	},
	computed: {
		departments():Department[] {
			return [
				Department.Secretariaat,
				Department.Sales,
				Department.TechnischeDienst,
				Department.DevWfShopOrOnline,
				Department.Programmatie,
				Department.Marketing,
				Department.Servicepakket,
				Department.Overzetting,
				Department.Boekhoudportaal
			];
		}
	},
	methods: {
		translateDepartment(dep:Department):string {
			return getDepartmentName(dep);
		},
		async onDepartmentChange(departmentId:Department, value:boolean) {
			if (value) {
				await SettingsService.joinDepartment(departmentId);
				this.joinedDepartments.push(departmentId);
			} else {
				await SettingsService.leaveDepartment(departmentId);
				let i = this.joinedDepartments.indexOf(departmentId);
				if (i == -1) return;
				this.joinedDepartments.splice(i, 1);
			}
		},
		isDepartmentSelected(dep:Department):boolean {
			return this.joinedDepartments.findIndex(d => d == dep) != -1;
		}
	},
	async created() {
		this.joinedDepartments = (await SettingsService.getJoinedDepartments()).map(d=>d.departmentId);
		this.ready = true;
	}
});
